import axios from "@/libs/api.request";
// 获取列表
export const getCollect = params => {
  return axios.request({
    url: "/finance/collect/bill",
    method: "get",
    params
  });
};

export const batchDelete = data => {
  return axios.request({
    url: "/finance/collect/bill/batchDelete",
    method: "delete",
    data
  });
};

export const add = data => {
  return axios.request({
    url: "/finance/collect/bill",
    method: "post",
    data
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/finance/collect/bill/${id}`,
    method: "get"
  });
};

export const exportItem = params => {
  return axios.request({
    url: `/finance/collect/bill/export/${params.id}`,
    method: "get"
  });
};

// 邮件预览
export const previewEmail = params => {
  return axios.request({
    url: `/finance/collect/bill/reviewEmail/${params.id}`,
    method: "get",
    params
  });
};

// 发送邮件
export const sendEmail = data => {
  return axios.request({
    url: `/finance/collect/bill/sendEmail`,
    method: "post",
    data
  });
};

export const details = params => {
  return axios.request({
    url: `/finance/collect/bill/details/${params.task_no}`,
    method: "get",
  });
};

export const adjustOff = data => {
  return axios.request({
    url: `/finance/collect/bill/adjustOff`,
    method: "post",
    data
  });
};

export const getRates = data => {
  return axios.request({
    url: `/finance/collect/bill/getRates`,
    method: "post",
    data
  });
};
export const saveRates = data => {
  return axios.request({
    url: `/finance/collect/bill/saveRates`,
    method: "post",
    data
  });
};

export const confirm = data => {
  return axios.request({
    url: `/finance/collect/bill/confirm/`+data.task_no,
    method: "post",
    data
  });
};
